module.exports = __webpack_public_path__ + "img/game6.1.354eb72d.png";